import { ModuleModel } from '../../module.model.interface';
import { ApiOrganizationDescriptor } from './api.organization';
import { ProfileModel } from '../../profile/model/profile.model';

export class OrganizationModel extends ApiOrganizationDescriptor implements ModuleModel {
  public discriminator = 'OrganizationDescriptor';

  public fullTitle?: string;
  public primaryContactDetail?: ProfileModel;
  public primaryContactFullName?: string;

  public clerkInfo?: any;
  public clerkDetail?: ProfileModel;
  public clerkFullName?: string;

  public organizationDetail?: OrganizationModel;

  constructor(options?: {
    id?: string;
    name?: string;
    mekhCode?: string;
    mekhCodeInternal?: string;
    primaryContact?: string;
    clerkId?: string;
    address?: string;
    site?: string;
    license?: string;
    owner?: string;
    teaorCode?: string;
    teaorDescription?: string;
    employeeCount?: number;
    trustedOrganization?: boolean;
    additionalInformation?: string;
    mustUseCompanyGateForCommunication?: boolean;
    filingSystemPartnerId?: string;
    href?: string;
    modified?: Date;
    deleted?: Date;
  }) {
    super();

    if (options) {
      if (options.id) { this.id = options.id; }
      if (options.name) { this.name = options.name; }
      if (options.mekhCode) { this.mekhCode = options.mekhCode; }
      if (options.mekhCodeInternal) { this.mekhCodeInternal = options.mekhCodeInternal; }
      if (options.primaryContact) { this.primaryContact = options.primaryContact; }
      if (options.clerkId) { this.clerkId = options.clerkId; }
      if (options.address) { this.address = options.address; }
      if (options.site) { this.site = options.site; }
      if (options.license) { this.license = options.license; }
      if (options.owner) { this.owner = options.owner; }
      if (options.teaorCode) { this.teaorCode = options.teaorCode; }
      if (options.teaorDescription) { this.teaorDescription = options.teaorDescription; }
      if (options.employeeCount) { this.employeeCount = options.employeeCount; }
      if (options.trustedOrganization) { this.trustedOrganization = options.trustedOrganization; } else { this.trustedOrganization = false; }
      if (options.additionalInformation) { this.additionalInformation = options.additionalInformation; }
      if (options.mustUseCompanyGateForCommunication) { this.mustUseCompanyGateForCommunication = options.mustUseCompanyGateForCommunication; } else { this.mustUseCompanyGateForCommunication = false; }
      if (options.filingSystemPartnerId) { this.filingSystemPartnerId = options.filingSystemPartnerId; }
      if (options.href) { this.href = options.href; }
      if (options.modified) { this.modified = options.modified; } else { this.modified = null; }
      if (options.deleted) { this.deleted = options.deleted; } else { this.deleted = null; }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/organization/model/organization.model.ts